import * as types from "../../actions/systemlevel/index";
export default function(state = [], action) {
  switch (action.type) {
    case types.FETCH_SCHEDULED_PAYROLL_WITHELD_DEDUCTION_LIST:
      return action.payload.data;
    default:
      return state;
  }
}
